import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { addCurrencySymbol } from '../../products/products/common/number_formatter';

const useStyles = createUseStyles((theme) => ({
    excess: {
        marginBottom: '2rem'
    }
}));

const AdditionalExcessCell = ({ additionalExcesses }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        additionalExcesses ? additionalExcesses.map((additionalExcess) => {
            const description = additionalExcess.getIn(['description']);
            const amount = additionalExcess.getIn(['amount']);

            const descriptionText = (description && description.endsWith('.')) ? description.slice(0, -1) : description;
            return (
                <div className={classes.excess} key={additionalExcess}>
                    {`${descriptionText} - ${addCurrencySymbol(amount)}`}
                </div>
            );
        }) : null
    );
};

AdditionalExcessCell.propTypes = {
    additionalExcesses: PropTypes.object
};

export { AdditionalExcessCell };
